import { BrowserRouter as Router } from "react-router-dom"
import { Routes } from "routing/Routes"
import { ThemeProvider } from "contexts/ThemeContext"

// import "react-datepicker/dist/react-datepicker.css";

function App() {
    return (
        <ThemeProvider>
            <Router>
                <Routes />
            </Router>
        </ThemeProvider>
    )
}

export default App
